// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_client_client_module_ts":"e1d047a32643fb6a","node_modules_dompurify_dist_purify_es_mjs":"1137f7aa740156be","node_modules_canvg_lib_index_es_js":"753547e3b6ac5555"}[chunkId] + ".js";
};